import { Pipe, PipeTransform } from '@angular/core';
import { GamificationProvider } from '../providers/gamification';

@Pipe({
  name: 'poinstUser'
})

export class PointsUserPipe implements PipeTransform {

  constructor(
    private gamificationProvider: GamificationProvider
  ) { }

  transform(value: string): any {
    return this.gamificationProvider.getUserPoints(value);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/user-points.pipe.ts